import requests from "./httpServices.js";

class CalendarService {
  async getStatus() {
    const response = await requests.get(`/calendar/status`);
    return response;
  }

  async getConnectUrl(provider) {
    const response = await requests.get(`/calendar/${provider}/connect`);
    return response;
  }

  async disconnect(provider) {
    const response = await requests.delete(`/calendar/${provider}`);
    return response;
  }

  async listCalendars(provider) {
    const response = await requests.get(`/calendar/${provider}/calendars`);
    return response;
  }

  async setCalendarId(provider, calendarId) {
    const response = await requests.patch(`/calendar/${provider}`, { calendarId });
    return response;
  }
}

const calendarService = new CalendarService();
export default calendarService;
